import { ReactNode } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { COMPACT_QUERY } from "../../../utils/hooks/useCompact";

const compact = "@media " + COMPACT_QUERY;

// Softer than the theme's error red: the asterisk marks a field, it does not
// report a failure. Matches the marker already used by the customer drawer.
const REQUIRED_MARK_COLOR = "#ff9f9f";

/** Bottom margin for a form control, so fields keep one rhythm across drawers. */
export const inputSx = { mb: 2, [compact]: { mb: 1.25 } };

interface FieldLabelProps {
  children: ReactNode;
  required?: boolean;
}

export function FieldLabel({ children, required = false }: FieldLabelProps) {
  return (
    <Typography variant="body2" fontWeight={500} sx={{ mb: 0.75 }}>
      {children}
      {required ? (
        <Box component="span" sx={{ color: REQUIRED_MARK_COLOR, ml: 0.5 }}>
          *
        </Box>
      ) : null}
    </Typography>
  );
}

export function SectionTitle({ children }: { children: ReactNode }) {
  return (
    <Typography
      sx={{
        mb: 2,
        [compact]: { mb: 1.25 },
        fontSize: 14,
        fontWeight: 700,
        textDecoration: "underline",
      }}
    >
      {children}
    </Typography>
  );
}
